import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'
import { Breadcrumb, Layout, Spin } from 'antd'

import { useSelector } from 'react-redux'
import { HomeOutlined } from '@ant-design/icons'
import capitalize from 'lodash/capitalize'
import React, { useMemo } from 'react'

import SimpleBar from 'simplebar-react'
import { useVerifyTokenQuery } from '../../../redux/app_api/_api'
import { getToken } from '../../utils'
import { MenuIdx } from '../menu'

const token = getToken()

const MainLayout = () => {
  const location = useLocation()
  const isMobileView = useSelector(s => s._settings.isMobileView)
  const isUserAuthorized = useSelector(s => s._auth.authorized)
  const { isFetching } = useVerifyTokenQuery(undefined, { skip: !token })

  if (isFetching) {
    return (
      <Spin tip={<span style={{ fontSize: '2rem' }}>Verifying credentials...</span>} size="large" style={{ top: '2rem' }}>
        <div />
      </Spin>
    )
  }
  if (!isUserAuthorized) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  return (
    <Layout hasSider={!isMobileView}>
      <MenuIdx />

      <Layout.Content
        style={{
          padding: '8px',
        }}
      >
        <SimpleBar style={{ height: '100%' }}>
          <div style={{ overflow: 'hidden' }}>
            <BreadV2 />
            <Outlet />
          </div>
        </SimpleBar>
      </Layout.Content>
    </Layout>
  )
}

export default MainLayout

const BreadV2 = () => {
  const { pathname } = useLocation()

  const pathSnippets = useMemo(() => {
    return pathname.split('/').filter(i => i !== '' && i !== 'dashboard')
  }, [pathname])

  const extraBreadcrumbItems = useMemo(() => {
    return pathSnippets.map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
      const title = capitalize(pathSnippets[index].replace(/-/g, ' '))

      return {
        key: url,
        title: <Link to={url}>{title}</Link>,
      }
    })
  }, [pathSnippets])

  const items = [
    {
      key: 'home',
      title: (
        <Link to="/dashboard">
          <HomeOutlined style={{ fontSize: '1rem' }} />
        </Link>
      ),
    },
    ...extraBreadcrumbItems,
  ]

  return <Breadcrumb style={{ fontSize: '1rem', marginBottom: 8 }} items={items} separator=">" />
}
